import React from 'react';

import Typography from '../../../basic/Typography';
import logo from '../../../../assets/vmonad-logo.svg';
import styles from './AuthLayout.module.css';

export function AuthLayout(props: { title: string; children: React.ReactNode }) {
  return (
    <div className={styles['auth-root']}>
      <div className={styles['auth-card']}>
        <div className={styles['brand']}>
          <img src={logo} alt="vMonad logo" className={styles['logo']} />
          <Typography variant="h2" align="center" gutterBottom>
            {props.title}
          </Typography>
        </div>
        {props.children}
      </div>
    </div>
  );
}
